import MenuItem from '@mui/material/MenuItem'
import type { CSSObject } from '../../theme/themeTypes'
import { styled } from '../../../utils/styled'

export const StyledMenuItem = styled(MenuItem)(
  ({ theme }): CSSObject => ({
    width: 'calc(100% + 20px)',
    margin: '0px -8px 0px -12px',
    borderRadius: theme.borderRadius.medium,
    borderWidth: '0px 8px 0px 12px',
    borderStyle: 'solid',
    borderColor: 'transparent',
    padding: '8px 0px',
    '&:hover': {
      backgroundColor: theme.tokens.background.main.pressed,
      borderColor: theme.tokens.background.main.pressed
    },
    '&.Mui-focusVisible': {
      backgroundColor: theme.tokens.background.main.pressed,
      borderColor: theme.tokens.background.main.pressed
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: theme.tokens.background.main.pressed,
        borderColor: theme.tokens.background.main.pressed
      }
    },
    '&.Mui-disabled': {
      color: theme.tokens.foreground.main.disabled,
      opacity: 1
    }
  })
)
